module.exports = __webpack_public_path__ + "static/media/attachments.62a50703.svg";